import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import SubscribeCard from '../Groups/SubscribeCard';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class AccessPortal extends Page {
  groups = [];
  bodyClass = 'access-portal';
  loading = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.loadProducts();
  }
  view() {
    return m("div", {
      className: "AccessPortal container"
    }, this.loading ? m(LoadingIndicator, null) : this.groups.length ? this.groupItems().toArray() : this.emptyState());
  }
  emptyState() {
    const isAdmin = app.session.user?.isAdmin();
    return m("div", {
      className: "AccessPortal-empty"
    }, m("p", null, app.translator.trans('floxum-payments.forum.access-portal.empty')), isAdmin && m("p", null, m("a", {
      href: app.forum.attribute('adminUrl') + '#/permissions'
    }, app.translator.trans('floxum-payments.forum.access-portal.empty-admin'))));
  }
  loadProducts() {
    const preloadedProducts = app.preloadedApiDocument();
    if (preloadedProducts) {
      // We must wrap this in a setTimeout because if we are mounting this
      // component for the first time on page load, then any calls to m.redraw
      // will be ineffective and thus any configs (scroll code) will be run
      // before stuff is drawn to the page.
      // @ts-ignore
      setTimeout(this.show.bind(this, preloadedProducts), 0);
    } else {
      app.request({
        url: app.forum.attribute('apiUrl') + '/floxum-products?filter[for]=pta',
        method: 'GET'
      }).then(this.show.bind(this));
    }
  }
  show(response) {
    // Filter out all groups that have a pta product set.
    const groups = app.store.all('groups').filter(group => group.blomstraPtaProduct());
    const products = response.data || [];

    // Assign the pta product to the group.
    groups.map(group => {
      group.product = products.find(product => product.id === group.blomstraPtaProduct());
    });

    // Assign groups that have a matching product.
    this.groups = groups.filter(group => group?.product);
    this.loading = false;
    m.redraw();
  }
  groupItems() {
    const items = new ItemList();
    this.groups.forEach(group => items.add(group.namePlural(), m(SubscribeCard, {
      group: group
    })));
    return items;
  }
}
flarum.reg.add('floxum-payments', 'forum/Pages/AccessPortal', AccessPortal);